import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { FilterMatchMode } from 'primereact/api';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import { useAuth } from '../contexts/AuthContext.js';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import '../config.js';
import { ScrollTop } from 'primereact/scrolltop';
import useStatusPageScript from '../hooks/useStatusPageScript.js';
import { ProgressBar } from 'primereact/progressbar';   
import { OverlayPanel } from 'primereact/overlaypanel';
import { Messages } from 'primereact/messages';
import { Tag } from 'primereact/tag';
import { Dialog } from 'primereact/dialog';
import { Toolbar } from 'primereact/toolbar';
import Login from './Login.js';
import { Toast } from 'primereact/toast';

const SupportHubAndRelay = () => {
  // Load the status page script
  useStatusPageScript();
  
  const { id } = useParams();
  const [events, setEvents] = useState([]);
  const navigate = useNavigate();
  const [rowSelectionModel, setRowSelectionModel] = useState([]);
  const { logout } = useAuth();
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    gateName: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    tileId: { value: null, matchMode: FilterMatchMode.CONTAINS },
    relayName: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });
  const [globalFilterValue, setGlobalFilterValue] = useState('');
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState(20);
  const op = useRef(null);
  const msgs = useRef(null);
  const [troubleShootDialog, setTroubleShootDialog] = useState(false);
  const [lms, setLms] = useState('the LMS');
  const [appid, setAppId] = useState(0);
  const [useAppId, setUseAppId] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const toast = useRef(null);

    const handleLoginSuccess = () => {
        setShowLoginModal(false);
        if (toast.current) {
            toast.current.show({severity: 'success', summary: '', detail: 'Login successful! You can continue working.'});
        }
        getEvents(rows, 0);
    };

  useEffect(() => {
    const fetchEvents = async () => {
        getEvents(rows,0);
    };

    let appid = localStorage.getItem('appid');
    if(appid !== null){
      setAppId(appid);
      setUseAppId(true);
    }

    fetchEvents();

    let _filters = JSON.parse(localStorage.getItem('clients-global'));
    if (_filters) {
      setFilters(_filters);
      setGlobalFilterValue(_filters['global'].value);
    }
  }, [id]);

  const getEvents = async () => {
    try {
        setLoading(true);
        setEvents([]);
        const token = localStorage.getItem('token');
        const id = localStorage.getItem('id');
        const tileId = localStorage.getItem('tileid');
        let url =  global.config.url + `/support/hubsrelay/${tileId}/${id}`;
        let appid = localStorage.getItem('appid');
        if(appid !== null || useAppId){
          url = url + `?appProviderId=${appid}`;
        }
        if (!tileId) {
          msgs.current.show({severity: 'error', summary: '', detail: 'Please select a tile first.'});
          setLoading(false);
          navigate('/support/tiles');
          return;
        }
        const response = await axios.get(url, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          setEvents(response.data);
          setLoading(false);
      } catch (error) {
        console.error('Error fetching event record:', error);
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            setShowLoginModal(true);
          }
          setLoading(false);
          setEvents([]);
      }
      

    };

  const onPageChange = (event) => {
    setLoading(true);
    setRows(event.rows);
    getEvents(event.rows, event.page);
  };
  
  const optionsSelected = (e, rowData) =>{
      op.current.toggle(e);
      setRowSelectionModel(rowData);
    }

  const optionsTemplate = (rowData) => {
    return <Button link icon="pi pi-ellipsis-v" onClick={(e) => optionsSelected(e, rowData)} />;
  };
  const startContent = (
      <React.Fragment>
        <div>
          {/* <Button onClick={() => getHubandRelay()} label="Get Hub and Relay" icon="pi pi-sitemap" className="p-button-success mb-3 ml-3" tooltip="Get hub and relay info for this tile" tooltipOptions={{position:"bottom"}}/> */}
          {/* <Button onClick={() => getTileLogs()} label="Get Tile Logs" icon="pi pi-file" className="p-button mb-3 ml-3" tooltip="Get clients for this location" tooltipOptions={{position:"bottom"}}/> */}
        </div>
      </React.Fragment>
  );

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters['global'].value = value;

    localStorage.setItem('clients-global', JSON.stringify(_filters));

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const clearFilter = () => {
  
  let _filters = { ...filters };
  _filters['global'].value = null;
  setFilters(_filters);
  setGlobalFilterValue('');
  localStorage.removeItem('clients-global');
};

const getSeverity = (option) => {
        switch (option) {
            case true:
                return 'success';
    
            case false:
                return 'danger';
    
            case null: 
                return 'warning';
            default:
                return null;
        }
    };
  const statusBodyTemplate = (relay) => {
          let value = "";
          // console.log(relay.relayStatus);
          switch(relay.relayStatus){
              case true:
                  value = "Relay online";
                  break;
              case false:
                  value = "Relay offline";
                  break;
              default:
                  value = "Unknown";
                  break;
          }
          return <Tag value={value} severity={getSeverity(relay.relayStatus)}></Tag>;
      };
        const hubStatusBodyTemplate = (relay) => {
          let value = "";
          // console.log(relay.relayStatus);
          switch(relay.hubStatus){
              case true:
                  value = "Hub online";
                  break;
              case false:
                  value = "Hub offline";
                  break;
              default:
                  value = "Unknown";
                  break;
          }
          return <Tag value={value} severity={getSeverity(relay.hubStatus)}></Tag>;
      };
      const allowedBodyTemplate = (ajax) => {
              return <Tag value={ajax.relayType ? "Allowed" : "Not Allowed"} severity={getSeverity(ajax.relayType)}></Tag>;
          };

      const goBack = () => {

      localStorage.removeItem('clients-global');
      navigate(-1);
    }

  const progressbar = (        
    <div className="card mt-3">
        <ProgressBar mode="indeterminate" style={{ height: '6px' }}></ProgressBar>
    </div>);

const openHubRelay = () => {
  
  msgs.current.show({severity: 'info', summary: '', detail: 'Hub and Relay are not yet implemented.'});
}
  
const getHelp = async (e, rowData) => {
    if(rowData === undefined || rowData.id === 0 || rowData.name === null){
      msgs.current.show({severity: 'error', summary: '', detail: 'Please select a client to get help.'});
    }
    else{
        if(rowData.relayStatus === true){
          msgs.current.show({severity: 'info', summary: '', detail: 'Hub and Relay are online. If the gate is not opening, please contact your installer to check the connections.', life: 30000, closable: true});
        }
        else if(rowData.relayStatus === false){
          // setHelpOffline(true);
          msgs.current.show({severity: 'info', summary: '', detail: 'Relay is offline. Please check the gate is powered, if it is please contact your installer to check the connections.', life: 30000, closable: true});
        }
        else if(rowData.relayStatus === null){
          // setHelpOffline(true);
          msgs.current.show({severity: 'info', summary: '', detail: 'Hub is offline. Please check the hub is powered, if it is showing red light please contact IT. If it is not showing any light, please check the socket is powered.', life: 30000, closable: true});
        }
        else{
          msgs.current.show({severity: 'error', summary: '', detail: 'Hub and Relay are not yet implemented.'});
        }
    }
    
  }

const helpTemplate = (rowData) => {
    return <Button link icon="pi pi-question-circle" onClick={(e) => getHelp(e, rowData)} />;
  };

  const logoutUser = async () => {
    await logout();
    navigate('/login');
  }
  return (
    <Card className='justify-content-md-center mt-5'>
      <Container fluid="md" >
      <div className="panel">
        <div className="flex align-content-center flex-wrap">
          <Button link icon="pi pi-arrow-left" onClick={() => goBack()} className='flex mb-3'/> 
          <h4 className='flex mt-2 mb-3'>Hub and relay info for {localStorage.getItem("tileid")}</h4> 
          <span className="p-input-icon-left mb-3 ml-3">
            <i className="pi pi-search" />
            <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Filter Search" tooltip="Start typing to filter" 
              tooltipOptions={{position: "bottom"}}/>

          </span>
          <Button icon="pi pi-times" className="p-button-text mb-3"  onClick={() => clearFilter()} tooltip="Clear filter" tooltipOptions={{position: "bottom"}} />
        </div>
        {/* <Toolbar           
        start={

        } 
        end = {        
          }/> */}
      </div>
      {loading && progressbar}
      <Messages ref={msgs} />
      <Toast ref={toast} />
        <Row className='justify-content-md-center mt-5'>
            <Col>
            <DataTable value={events} selectionMode={'radiobutton'} selection={rowSelectionModel} onSelectionChange={(e) => setRowSelectionModel(e.value.id)} 
            dataKey="relayName" tableStyle={{ minWidth: '50rem' }} filters={filters} filterDisplay="menu" emptyMessage={loading ? "Loading hub and relat info..." : "No hub and relay found."}
            globalFilterFields={['gateName', 'tileId', 'relayName']}  
            scrollable scrollHeight="60vh">
                {/* <Column field="options" header="" body={optionsTemplate}> </Column> */}
                <Column field="gateName" header="Name" showFilterMenu={false} filterMenuStyle={{ width: '14rem' }} style={{ minWidth: '12rem' }} sortable></Column>
                <Column field="tileId" header="Tile ID" showFilterMenu={false} filterMenuStyle={{ width: '14rem' }} style={{ minWidth: '12rem' }} sortable></Column>
                <Column header="Relay Status" body={statusBodyTemplate} ></Column>
                <Column header="Hub Status" body={hubStatusBodyTemplate} ></Column>
                <Column field="relayName" header="Relay Name" showFilterMenu={false} filterMenuStyle={{ width: '14rem' }} style={{ minWidth: '12rem' }} sortable></Column>
                <Column header="Relay Type" body={allowedBodyTemplate} ></Column>
                <Column field="help" header="" body={helpTemplate}> </Column>
            </DataTable>
            </Col>

        </Row>
        {/* <Button label="Troubleshoot" icon="pi pi-wrench" className="p-button-warning mb-3 ml-3" onClick={() => setTroubleShootDialog(true)} tooltip="Open Troubleshoot guide" tooltipOptions={{position:"bottom"}}/> */}
        <OverlayPanel ref={op}>
            {startContent}
          </OverlayPanel>
          <div className="card flex justify-content-center">
            <Dialog className='justify-content-center' visible={troubleShootDialog} onHide={() => setTroubleShootDialog(false)}>
            <div className="card">
              <Toolbar className='' start={<h4>Troubleshoot guide</h4>}/>
              </div>
            <div className='justify-content-md-center mt-5'>
              <React.Fragment>
                <ul>
                <li> Got to C:\ProgramData\CCTech\SmartTile\Client\st-event.log and check that Smart Tile is receiving the scans if not, restart Smart Tile Client service. </li>
                  <li>If Smart Tile still does not receive the scans, check the network connection and that SmartTile server's URL has been added to the Firewall (http://mfapi.smarttile.co.uk) </li>
                  <li> If Smart Tile is receiving the scans but not getting into {lms} please restart {lms}</li>
                  <li> If after restarting {lms} it still does not receive the scans. Check that the cables are correctly connected. </li>
                  <li> If they are, please check the COM ports in Device Manager match with the one set in {lms} and the ones set in Smart Tile (<a href='/support/tiles'>see tiles page</a> for more details)</li>
                  <li> Another good practice would be to restart the PC in case the COM ports are frozen.</li>
                  <li> If {lms} is receiving the scans correctly but the gate is not opening, check that we are receiving the open gate commands in C:\ProgramData\CCTech\SmartTile\Client\st-event.log</li>
                  <li> If we are not receiving them restart Smart Tile Client and/or check the access rules in {lms}</li>
                  <li> If we are receiving them, there could be a problem with the controller, check that it is running correctly; if hub and relay please hub and relays status for these clients <a href="#" onClick={() => openHubRelay()}>here</a>.</li>
                  <li> If the problem persists, please open a support ticket.</li>
                </ul>
                <Button label="Open Support Ticket" icon="pi pi-ticket" className="p-button-success mb-3 ml-3" onClick={() => navigate('/support/tickets/create')} tooltip="Open a support ticket for this client" tooltipOptions={{position:"bottom"}}/>
              </React.Fragment>
            </div>
            </Dialog>
          </div>
          <div className="card flex justify-content-center">
            <Dialog 
              header="Session Expired - Please Login Again" 
              visible={showLoginModal} 
              style={{ width: '450px' }} 
              modal={true}
              closable={false}
              className="justify-content-center"
            >
              <p className="mb-3">Your session has expired. Please log in again to continue working without losing your form data.</p>
              <div className="flex justify-content-center">
                <Login onLoginSuccess={handleLoginSuccess} />
              </div>
            </Dialog>
          </div>
      </Container>
    <ScrollTop />
    </Card>
  );
};

export default SupportHubAndRelay;
